import './App.css'
import { App as ANTDApp, ConfigProvider, theme } from 'antd'
import { Outlet } from 'react-router-dom'
import 'dayjs/locale/fr'
import frFR from 'antd/locale/fr_FR'
import enUS from 'antd/locale/en_US'
import { useLang } from './hooks/useLang'
import { setupAxios } from './helpers/setupAxios'
import axios from 'axios'
import { AuthProvider } from './contexts/Auth'
import SBRM from './modules/sbrm/SBRM'
import dayjs from 'dayjs'
import i18n from './i18n/setupLocalization'
import Gleap from 'gleap'
import { LoadingFullScreen } from './layout/LoadingFullScreen'

const { defaultAlgorithm, darkAlgorithm } = theme

function App() {
  const { selectedLocale } = useLang()

  setupAxios(axios)
  i18n.changeLanguage(selectedLocale)

  /**
   * Setup dayjs locale globally
   */
  dayjs.locale(selectedLocale)

  /**
   * Setup Gleap locale globally
   */
  Gleap.setLanguage(selectedLocale)

  return (
    <ConfigProvider
      locale={selectedLocale === 'fr' ? frFR : enUS}
      theme={{
        algorithm: defaultAlgorithm,
        token: {
          colorPrimary: '#a58aeb',
          colorLink: '#666',
        },
        components: {
          Table: {
            headerColor: '#a58aeb',
          },
          Statistic: {
            contentFontSize: 16,
            titleFontSize: 12,
          },
        },
      }}
    >
      <ANTDApp>
        <AuthProvider loadingLayout={<LoadingFullScreen />}>
          <Outlet />
          <SBRM />
        </AuthProvider>
      </ANTDApp>
    </ConfigProvider>
  )
}

export default App
